module.exports = __webpack_public_path__ + "img/img37.73406889.svg";